import { jsx as _jsx } from "react/jsx-runtime";
import { TooltipContent } from "./MoreInfo.styles";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import Tooltip from "@mui/material/Tooltip";
export const MoreInfo = (props) => {
    const { children, iconColor, ...tooltipProps } = props;
    return (_jsx(Tooltip, { ...tooltipProps, title: _jsx(TooltipContent, { children: children }), children: _jsx(InfoOutlined, { sx: { color: iconColor !== null && iconColor !== void 0 ? iconColor : "initial" } }) }));
};
